export const AppContainerId = 'veilederSlettingAvRenter';
export const BoksA = 'boks-a';
export const BoksB = 'boks-b';
export const BoksC = 'boks-c';